var _templateObject, _templateObject2, _templateObject3;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// eslint-disable-next-line no-unused-vars
import { gql, ApolloClient } from '@apollo/client';
import { prefixedLogger } from '../../utils';
var logPrefix = '[StorefrontApi:Checkout]';
var logDebug = prefixedLogger(logPrefix);
var logError = prefixedLogger(logPrefix, console.error);
var CHECKOUT_CREATE_MUTATION = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation createCheckout($input: CheckoutCreateInput!) {\n      checkoutCreate(input: $input) {\n        checkout {\n          id\n          ready\n          webUrl\n          customAttributes {\n            key\n            value\n          }\n          lineItemsSubtotalPrice {\n            amount\n            currencyCode\n          }\n          lineItems(first: 10) {\n            edges {\n              node {\n                id\n                quantity\n                title\n                unitPrice {\n                  amount\n                }\n                variant {\n                  id\n                  sku\n                  title\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n"]))); // eslint-disable-next-line no-unused-vars

var CHECKOUT_UPDATE_SHIPPING_ADDRESS_MUTATION = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation updateCheckoutShippingAddress($id: ID!, $input: MailingAddressInput!) {\n    checkoutShippingAddressUpdateV2(checkoutId: $id, shippingAddress: $input) {\n      checkout {\n        shippingAddress {\n          firstName\n          lastName\n          address1\n          address2\n          city\n          province\n          countryCodeV2\n          zip\n        }\n        availableShippingRates {\n          ready\n          shippingRates {\n            handle\n            title\n            handle\n            priceV2 {\n              amount\n              currencyCode\n            }\n          }\n        }\n        shippingDiscountAllocations {\n          discountApplication {\n            targetType\n            targetSelection\n            allocationMethod\n            value {\n              ... on MoneyV2 {\n                currencyCode\n                amount\n              }\n              ... on PricingPercentageValue {\n                percentage\n              }\n            }\n          }\n          allocatedAmount {\n            amount\n            currencyCode\n          }\n        }\n        discountApplications(first: 5) {\n          nodes {\n            targetType\n            targetSelection\n            allocationMethod\n            value {\n              ... on MoneyV2 {\n                amount\n                currencyCode\n              }\n              ... on PricingPercentageValue {\n                percentage\n              }\n            }\n            ... on ScriptDiscountApplication {\n              title\n            }\n          }\n        }\n      }\n      checkoutUserErrors {\n        code\n        field\n        message\n      }\n    }\n  }\n"]))); // eslint-disable-next-line no-unused-vars

var CHECKOUT_QUERY = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query checkoutQuery($id: ID!) {\n    node(id: $id) {\n      ... on Checkout {\n        webUrl,\n        customAttributes {\n          key\n          value\n        }\n        lineItems(first: 15) {\n          nodes {\n            id\n            title\n            quantity\n            unitPrice {\n              amount\n              currencyCode\n            }\n            variant {\n              id\n              title\n              sellingPlanAllocations(first: 5) {\n                nodes {\n                  sellingPlan {\n                    id\n                    name\n                    description\n                  }\n                }\n              }\n            }\n          }\n        }\n        shippingAddress {\n          firstName\n          lastName\n          address1\n          address2\n          city\n          province\n          countryCodeV2\n          zip\n        }\n        availableShippingRates {\n          ready\n          shippingRates {\n            handle\n            title\n            handle\n            priceV2 {\n              amount\n              currencyCode\n            }\n          }\n        }\n        shippingDiscountAllocations {\n          discountApplication {\n            targetType\n            targetSelection\n            allocationMethod\n            value {\n              ... on MoneyV2 {\n                currencyCode\n                amount\n              }\n              ... on PricingPercentageValue {\n                percentage\n              }\n            }\n          }\n          allocatedAmount {\n            amount\n            currencyCode\n          }\n        }\n        discountApplications(first: 5) {\n          nodes {\n            targetType\n            targetSelection\n            allocationMethod\n            value {\n              ... on MoneyV2 {\n                amount\n                currencyCode\n              }\n              ... on PricingPercentageValue {\n                percentage\n              }\n            }\n            ... on ScriptDiscountApplication {\n              title\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * @typedef {Object} CheckoutBuyerIdentityInput
 * @property {string} countryCode
 */

/**
 * @typedef {Object} AttributeInput
 * @property {string} key
 * @property {string} value
 */

/**
 * @typedef {Object} CheckoutLineItemInput
 * @property {Array.<AttributeInput>|null} customAttributes
 * @property {number} quantity
 * @property {string} variantId
 */

/**
 * @typedef {Object} MoneyV2
 * @property {number} amount
 * @property {string} currencyCode
 */

/**
 * @typedef {Object} MailingAddressInput
 * @property {string} [address1]
 * @property {string|null} [address2]
 * @property {string} city
 * @property {string|null} [company]
 * @property {string} country
 * @property {string} province
 * @property {string} zip
 * @property {string} [firstName]
 * @property {string} [lastName]
 * @property {string|null} [phone]
 */

/**
 * @typedef {Object} CheckoutInput
 * @property {Boolean|null} [allowPartialAddresses]
 * @property {CheckoutBuyerIdentityInput|null} [buyerIdentity]
 * @property {Array.<AttributeInput>|null} [customAttributes]
 * @property {string|null} [email]
 * @property {Array.<CheckoutLineItemInput>} [lineItems]
 * @property {string|null} [note]
 * @property {MailingAddressInput|null} [shippingAddress]
 */

/**
 * @typedef {Object} ShippingRate
 * @property {string} handle
 * @property {MoneyV2} priceV2
 * @property {string} title
 */

/**
 * @typedef {Object} AvailableShippingRates
 * @property {boolean} ready
 * @property {Array.<ShippingRate>} shippingRates
 */

/**
 *
 * @param {ApolloClient} client
 * @param {CheckoutInput} checkoutInput
 *
 * @return {Promise<{id: string, webUrl: string}>}
 */

export function mutateCreateCheckout(_x, _x2) {
  return _mutateCreateCheckout.apply(this, arguments);
}
/**
 * Updates the shipping address on the given checkout.
 * @param {ApolloClient} client
 * @param {string} checkoutId - global id for checkout in the format gid://shopify/Checkout/<alpha-numeric id>
 * @param {MailingAddressInput} shippingAddress
 * @return {Promise<*>}
 */

function _mutateCreateCheckout() {
  _mutateCreateCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(client, checkoutInput) {
    var result, _result$data$checkout, checkout, checkoutUserErrors;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logDebug("Creating checkout: ".concat(JSON.stringify(checkoutInput)));
            _context.next = 3;
            return client.mutate({
              mutation: CHECKOUT_CREATE_MUTATION,
              variables: {
                input: checkoutInput
              }
            });

          case 3:
            result = _context.sent;
            logDebug('Checkout create result', result);
            _result$data$checkout = result.data.checkoutCreate;
            _result$data$checkout = _result$data$checkout === void 0 ? {} : _result$data$checkout;
            checkout = _result$data$checkout.checkout, checkoutUserErrors = _result$data$checkout.checkoutUserErrors;

            if (!(typeof checkoutUserErrors !== 'undefined' && checkoutUserErrors.length > 0)) {
              _context.next = 11;
              break;
            }

            logError('Failed to create checkout', {
              checkoutUserErrors: checkoutUserErrors
            });
            throw new Error('Failed to create checkout');

          case 11:
            logDebug('Checkout created', {
              id: checkout.id,
              checkout: checkout
            });
            return _context.abrupt("return", checkout);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _mutateCreateCheckout.apply(this, arguments);
}

export function mutateUpdateCheckoutShippingAddress(_x3, _x4, _x5) {
  return _mutateUpdateCheckoutShippingAddress.apply(this, arguments);
}
/**
 * Updates the shipping address on the given checkout.
 * @param {ApolloClient} client
 * @param {string} checkoutId - global id for checkout in the format gid://shopify/Checkout/<alpha-numeric id>
 * @return {Promise<*>}
 */

function _mutateUpdateCheckoutShippingAddress() {
  _mutateUpdateCheckoutShippingAddress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(client, checkoutId, shippingAddress) {
    var result, _result$data$checkout2, checkout, checkoutUserErrors;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.mutate({
              mutation: CHECKOUT_UPDATE_SHIPPING_ADDRESS_MUTATION,
              variables: {
                id: checkoutId,
                input: shippingAddress
              }
            });

          case 2:
            result = _context2.sent;
            logDebug('Checkout update address result', result);
            _result$data$checkout2 = result.data.checkoutShippingAddressUpdateV2, checkout = _result$data$checkout2.checkout, checkoutUserErrors = _result$data$checkout2.checkoutUserErrors;
            return _context2.abrupt("return", {
              checkout: checkout,
              checkoutUserErrors: checkoutUserErrors
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _mutateUpdateCheckoutShippingAddress.apply(this, arguments);
}

export function queryCheckout(_x6, _x7) {
  return _queryCheckout.apply(this, arguments);
}

function _queryCheckout() {
  _queryCheckout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(client, checkoutId) {
    var result, checkout;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.query({
              query: CHECKOUT_QUERY,
              variables: {
                id: checkoutId
              },
              // Important: without the network-only setting, cached data is returned when the variables haven't changed.
              // Thus, it will show outdated information (especially with respect to the shipping rates
              fetchPolicy: 'network-only'
            });

          case 2:
            result = _context3.sent;
            logDebug('Checkout query result', result);
            checkout = result.data.node;
            return _context3.abrupt("return", checkout);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryCheckout.apply(this, arguments);
}